import { useCrmEnrichmentJobToggleMutation } from "app/pages/sales-intelligence/modules/crm-enrichment/query/mutations/useCrmEnrichmentJobToggleMutation";

import { hubspotEnrichmentQueryKeys } from "../queries/queryKeyFactory";
import hubspotEnrichmentAPIService from "../services/api/hubspotEnrichmentAPIService";

export default function useHsEnrichmentJobToggleMutation() {
    return useCrmEnrichmentJobToggleMutation({
        apiService: hubspotEnrichmentAPIService,
        queryKeys: hubspotEnrichmentQueryKeys,
    });
}
